import * as React from 'react'

import Group from '../tabs/registry/views/Group'
import { RouteComponentProps } from '@/app/navigation/withRouter'

interface RouteParams {
  companyId: string
}

export const VehicleListPage: React.FC<RouteComponentProps<RouteParams>> = ({
  match,
}) => {
  const { companyId } = match.params

  return (
    <section className="tw-flex tw-w-full tw-h-full tw-flex-col">
        <Group companyId={companyId} />
    </section>
  )
}
